"use client";

import { EyeIcon, EyeOffIcon } from "@/components/icons";
import SearchableSelect from "@/components/Auth/AuthModal/SearchableSelect";
import MultiSelect from "@/components/Auth/AuthModal/MultiSelect";
import { useTranslations } from "next-intl";
import React, { useId, useState } from "react";

interface PddRegisterFormProps {
  onDone: () => void;
}

const REGIONS = [
  "Астана",
  "Алматы",
  "Шымкент",
  "Абайская область",
  "Акмолинская область",
  "Актюбинская область",
  "Алматинская область",
  "Атырауская область",
  "Восточно-Казахстанская область",
  "Жамбылская область",
  "Жетысуская область",
  "Западно-Казахстанская область",
  "Карагандинская область",
  "Костанайская область",
  "Кызылординская область",
  "Мангистауская область",
  "Павлодарская область",
  "Северо-Казахстанская область",
  "Туркестанская область",
  "Улытауская область",
];

const LICENSE_CATEGORIES = [
  "A",
  "A1",
  "B",
  "B1",
  "C",
  "C1",
  "D",
  "D1",
  "BE",
  "CE",
  "DE",
  "Tm",
  "Tb",
];

const PddRegisterForm: React.FC<PddRegisterFormProps> = ({ onDone }) => {
  const t = useTranslations();

  const [region, setRegion] = useState("");
  const [category, setCategory] = useState<string[]>([]);
  const [iin, setIin] = useState("");
  const [fullName, setFullName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const iinId = useId();
  const fullNameId = useId();
  const passwordId = useId();

  const inputClass =
    "w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent";

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onDone();
  };

  return (
    <div className="w-full">
      <h2 className="text-[14px] font-bold text-gray-800 mb-6 text-center">
        {t("btn-register")}
      </h2>

      <form className="space-y-4" onSubmit={handleSubmit}>
        <SearchableSelect
          value={region}
          onChange={setRegion}
          options={REGIONS}
          placeholder="Выберите регион"
        />

        <MultiSelect
          value={category}
          onChange={setCategory}
          options={LICENSE_CATEGORIES}
          placeholder="Выберите категории прав"
          itemSuffix="категория"
        />

        <label htmlFor={iinId} className="sr-only">
          ИИН
        </label>
        <input
          id={iinId}
          type="text"
          inputMode="numeric"
          maxLength={12}
          placeholder="ИИН"
          className={inputClass}
          value={iin}
          onChange={(e) => setIin(e.target.value.replace(/\D/g, ""))}
          required
        />

        <label htmlFor={fullNameId} className="sr-only">
          ФИО
        </label>
        <input
          id={fullNameId}
          type="text"
          autoComplete="name"
          placeholder="ФИО"
          className={inputClass}
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          required
        />

        <label htmlFor={passwordId} className="sr-only">
          {t("label-password")}
        </label>
        <div className="relative">
          <input
            id={passwordId}
            type={showPassword ? "text" : "password"}
            autoComplete="new-password"
            placeholder={t("label-password")}
            className={`${inputClass} pr-10`}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
          >
            {showPassword ? <EyeOffIcon size={20} /> : <EyeIcon size={20} />}
          </button>
        </div>

        <button
          type="submit"
          className="cursor-pointer w-full py-3 rounded-lg font-medium text-white transition-all shadow-md h-[50px] md:h-auto"
          style={{ backgroundColor: "#5AA06F" }}
        >
          {t("btn-register")}
        </button>

        <p className="text-xs text-gray-500 text-center mt-4">
          {t.rich("label-register-policy-agreement", {
            terms: (chunks) => (
              <a href="#" className="text-blue-600 hover:underline">
                {chunks}
              </a>
            ),
            privacy: (chunks) => (
              <a href="#" className="text-blue-600 hover:underline">
                {chunks}
              </a>
            ),
          })}
        </p>
      </form>
    </div>
  );
};

export default PddRegisterForm;
